<div class="manual-container">
  <p>Actulalizar robots de bancos automaticamente</p>
  <div class="search">
    <button class="space-node" type="submit" (click)="updateBanks()">Actualizar</button>
  </div>
  <div class="container-loading">
    <mat-spinner *ngIf="charging"></mat-spinner>
  </div>
</div>
